import * as React from 'react';

import { ProjPage } from './ProjPage'; 
import { Webapp } from './Webapp'; 


import 'semantic-ui-css/semantic.min.css';
import '../css/App.css';

import { observer } from 'mobx-react';
import { observable } from 'mobx';

@observer
export class App extends React.Component {
    @observable displayApp: boolean;

    constructor(props: any, context: any) {
        super(props, context);
        this.displayApp = false;
    }
    public render() {
        return <div className="content overflow">
        <section className="title">
            <a href="/">Attention Model Explorer</a>
        </section>
        <section>
            <p>
                <span onClick={() => {this.displayApp = false}} className={this.displayApp ? 'opt' : 'selected-opt'}>[Show project page]</span> | <span 
            onClick={() => {this.displayApp = true}} className={!this.displayApp ? 'opt' : 'selected-opt'}>[Show web app system]</span></p>
        </section>
      
        <section>
            <p><strong>Team Members</strong>: Tongshuang Wu, Zhihang Dong, Sicheng Song, Mingrui Zhang</p>
        </section>
        
        <div className='full-width'>
            {this.displayApp ? <Webapp /> : <ProjPage/>}
        </div>
        
        <div className="footer">
          <a href="https://cse512-18s.github.io/">CSE 512 Data Visualization</a> -
          <a href="http://www.washington.edu">University of Washington</a>
        </div>
      
      </div>;
    }
}


// WEBPACK FOOTER //
// ./src/components/App.tsx